import { useEffect, useState } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import PreOrder from "@/components/PreOrder";
import About from "@/components/About";
import Testimonials from "@/components/Testimonials";
import PaymentInfo from "@/components/PaymentInfo";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import Chatbot from "@/components/Chatbot";
import SmoothScroll from "@/components/SmoothScroll";

export default function LandingPage() {
  const [reveal, setReveal] = useState(false);
  useEffect(() => {
    setReveal(true);
  }, []);

  return (
    <main
      data-testid="landing-page"
      className={`relative min-h-screen overflow-x-hidden transition-opacity duration-700 ${
        reveal ? "opacity-100" : "opacity-0"
      }`}
    >
      <SmoothScroll />
      <Navbar />
      <Hero />
      <Marquee />
      <Services />
      <PreOrder />
      <About />
      <Testimonials />
      <PaymentInfo />
      <ContactSection />
      <Footer />
      <Chatbot />
    </main>
  );
}
